export enum Currency {
  USD = 'USD',
}

export interface CurrencyInfo {
  symbol: string;
  name: string;
}

export const currencyInfo: Record<Currency, CurrencyInfo> = {
  [Currency.USD]: {
    symbol: '$',
    name: 'US Dollar',
  },
};
